export const LOOK_BACK_DAYS_FOR_EVENTS = process.env.VUE_APP_LOOK_BACK_DAYS_FOR_EVENTS
export const LOOK_BACK_DAYS_FOR_NOTES = process.env.VUE_APP_LOOK_BACK_DAYS_FOR_NOTES
export const URGENT_EVENT_SEVERITY = 4

export const PATIENT_STATS_PAGE_TYPES = {
  SUMMARY: { key: 'summary', label: 'SUMMARY' },
  MAPPING: { key: 'mapping', label: 'MAPPING' },
  DETAILED: { key: 'detailed', label: 'DETAILED' },
  EXERCISE: { key: 'exercise', label: 'EXERCISE' },
  NOTES: { key: 'notes', label: 'NOTES' },
  ACTIGRAPHY: { key: 'actigraphy', label: 'ACTIGRAPHY' },
}

export const MAP_STATUSES = { Good: 'Good', Attention: 'Attention', Critical: 'Critical' }
export const GENERIC_STATUSES = { Good: 'Good', Attention: 'Attention', Critical: 'Critical' }

export const MINUTES_BEFORE_OUT_OF_ROOM = process.env.VUE_APP_MINUTES_BEFORE_OUT_OF_ROOM || 60
export const MINUTES_BEFORE_VIBE_OFFLINE = process.env.VUE_APP_MINUTES_BEFORE_VIBE_OFFLINE || 120

export const AGT_DEBUG = JSON.parse((process.env.VUE_APP_AGT_DEBUG || 'False').toLowerCase())
